import { TaskPassport } from '@sisense/task-manager';
export class QueryTaskPassport extends TaskPassport {
    constructor(type, queryDescription, executionConfig) {
        super();
        this.queryDescription = queryDescription;
        this.type = type;
        this.executionConfig = executionConfig;
    }
}
export class PivotQueryTaskPassport extends TaskPassport {
    constructor(type, pivotQueryDescription, executionConfig) {
        super();
        this.pivotQueryDescription = pivotQueryDescription;
        this.type = type;
        this.executionConfig = executionConfig;
    }
}
//# sourceMappingURL=query-task-passport.js.map